import React from "react";

const HeaderSearchNew = props => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.3098 13.253C15.4756 11.851 16.178 10.0507 16.178 8.08916C16.178 3.62878 12.5493 0 8.089 0C3.6287 0 0 3.62878 0 8.08916C0 12.5492 3.6287 16.1777 8.089 16.1777C10.0506 16.1777 11.851 15.4754 13.253 14.3097L17.9434 19L19 17.9433L14.3098 13.253ZM8.089 14.6832C4.45273 14.6832 1.49444 11.7251 1.49444 8.08916C1.49444 4.45281 4.45273 1.49443 8.089 1.49443C11.7252 1.49443 14.6836 4.45281 14.6836 8.08916C14.6836 11.7251 11.7253 14.6832 8.089 14.6832Z"
        fill="#292D37"
      />
    </svg>
  );
};

export default HeaderSearchNew;
